import { Button, Space, Row, Col, Card, Divider, Tag, Empty } from 'antd';
import { useEffect, useState } from 'react';
import { ApartmentOutlined, SyncOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import './App.css';
import useGetNews from "../../hooks/useGetNews";
import { useGetServerStatus } from '../../hooks/useGetAdmin'
import { useNavigate } from 'react-router-dom';
import { Editor, EditorState, convertFromRaw } from 'draft-js';

function App() {
  const { data, isFetching, error, refetch } = useGetNews();
  const { data: serverData, isFetching: serverStatus, isSuccess, isError } = useGetServerStatus();
  const navigate = useNavigate();

  const [onlineStatus, setOnlineStatus] = useState('processing');
  const [onlinePlayers, setOnlinePlayers] = useState(0);

  const convertDate = (date) => {
    const d = new Date(date);
    return d.toLocaleString();
  }

  useEffect(() => {
    if (isSuccess || serverData?.Data) {
      setOnlineStatus('online')
      setOnlinePlayers(serverData?.Data?.clients);
    } else if (isError) {
      setOnlineStatus('offline')
    }
  }, [serverData, isSuccess, isError])

  return (
    <>
      <div>
        <h2>News & Announcements</h2>
      </div>

      <Row align="top" justify="center" gutter={15}>
        {(isFetching || error) && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}

        {!isFetching && !error && (
          <>
            <Col span={20}>
              {data && data.length === 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
              {data && data.map((item) => {
                const content = JSON.parse(item?.content);
                const contentState = convertFromRaw(content);
                const editorState = EditorState.createWithContent(contentState);

                return (
                  <Card key={item.id} type="inner" style={{ width: '100%', marginBottom: 15 }} title={item.title} loading={isFetching} extra={(
                    <>
                      <Button type="link" onClick={() => navigate(`/forums/${item.category}/${item.id}`)}>View More</Button>
                      <i>{convertDate(item.submitted)}</i>
                    </>
                  )}>
                    <Editor editorState={editorState} readOnly />
                  </Card>
                )
              })}
            </Col>

            <Col span="auto">
              <Space size='middle' direction="vertical" style={{ width: '100%' }}>
                <Card type="inner" title="CityLife Roleplay" style={{ width: '100%' }}>
                  <Button icon={<ApartmentOutlined />} type="primary" onClick={() => refetch()}>Connect to Server</Button>

                  <Divider />

                  <Card size="middle" bodyStyle={{ backgroundColor: 'rgba(0,0,0,0.1)' }}>
                    <p style={{ padding: 0, margin: 0, marginBottom: 5, fontWeight: 'bold' }}>Server Status</p>
                    {onlineStatus === 'processing' ? (
                      <Tag icon={<SyncOutlined spin />} color="processing">
                        Checking...
                      </Tag>
                    ) : (
                      onlineStatus === 'online' ? (
                        <Tag icon={<CheckCircleOutlined />} color="success">
                          Online - {onlinePlayers}
                        </Tag>
                      ) : (
                        <Tag icon={<ExclamationCircleOutlined />} color="error">
                          Offline
                        </Tag>
                      )
                    )}

                    {onlineStatus === 'online' && (
                      <div style={{ marginTop: 10 }}>
                        <Button type="default" onClick={() => navigate('/')}>Upvote Server</Button>
                      </div>
                    )}
                  </Card>
                </Card>
                <Card type="inner" title="Online members" style={{ width: 300 }}>
                  <p>... coming soon?</p>
                </Card>
              </Space>
            </Col>
          </>
        )}
      </Row>
    </>
  );
}

export default App;
